import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _b4fdca8e = () => interopDefault(import('../../../pages/old/App.vue' /* webpackChunkName: "" */))
const _58832472 = () => interopDefault(import('../../../pages/old/home/home.vue' /* webpackChunkName: "" */))
const _45aa0bc7 = () => interopDefault(import('../../../pages/old/ajkRank/xiaoqu/communityHot.vue' /* webpackChunkName: "" */))
const _33a92464 = () => interopDefault(import('../../../pages/old/rank/borkerRank/borkerRank.vue' /* webpackChunkName: "" */))
const _903e0140 = () => interopDefault(import('../../../pages/old/rank/storeRank/storeRank.vue' /* webpackChunkName: "" */))
const _09296552 = () => interopDefault(import('../../../pages/old/ajkRank/qiangshou/index.vue' /* webpackChunkName: "" */))
const _27310763 = () => interopDefault(import('../../../pages/old/wakeAPP/wakeAPP.vue' /* webpackChunkName: "" */))
const _9f656858 = () => interopDefault(import('~/layouts/non-available.vue' /* webpackChunkName: "" */))
const _2a1e7119 = () => interopDefault(import('../../../pages/captcha-wangyi/index.vue' /* webpackChunkName: "" */))
const _30afa829 = () => interopDefault(import('../../../pages/captcha-geetest/index.vue' /* webpackChunkName: "" */))
const _99ace6c2 = () => interopDefault(import('../../../pages/trendency/index.vue' /* webpackChunkName: "" */))
const _b4ca1c58 = () => interopDefault(import('../../../pages/old/ajkRank/synList/synList.vue' /* webpackChunkName: "" */))
const _89067158 = () => interopDefault(import('../../../pages/esf-package/index.vue' /* webpackChunkName: "" */))
const _50b081ff = () => interopDefault(import('../../../pages/map/index.vue' /* webpackChunkName: "" */))
const _678b01d6 = () => interopDefault(import('../../../pages/agreement/carrier/index.vue' /* webpackChunkName: "" */))
const _e6fc7bae = () => interopDefault(import('../../../pages/weak/miniProgram/index.vue' /* webpackChunkName: "" */))
const _30cc39a8 = () => interopDefault(import('../../../pages/common-material/index.vue' /* webpackChunkName: "" */))
const _7dd39a64 = () => interopDefault(import('../../../pages/samsung-download/index.vue' /* webpackChunkName: "" */))
const _57f0a0c9 = () => interopDefault(import('../../../pages/app/download/index.vue' /* webpackChunkName: "" */))
const _6222cd93 = () => interopDefault(import('~/layouts/error.vue' /* webpackChunkName: "" */))

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/",
    component: _b4fdca8e,
    alias: "/feapp",
    name: "App",
    children: [{
      path: ":city([a-z]+)/",
      component: _58832472,
      name: "mHome"
    }, {
      path: "ershou-autorank/xiaoqu",
      component: _45aa0bc7,
      name: "communityHot"
    }, {
      path: "ershou-autorank/broker",
      component: _33a92464,
      name: "brokerRank"
    }, {
      path: "ershou-autorank/store",
      component: _903e0140,
      name: "storeRank"
    }, {
      path: "ershou-autorank/fangyuan/qiangshou/*",
      component: _09296552,
      name: "qiangshou"
    }, {
      path: "ershou-autorank/fangyuan/pinzhi/*",
      component: _09296552,
      name: "pinzhi"
    }, {
      path: "ershou-autorank/fangyuan/*",
      component: _09296552,
      name: "houseRank"
    }, {
      path: "/wake/app",
      component: _27310763,
      name: "wakeApp"
    }]
  }, {
    path: "/non-available",
    component: _9f656858,
    name: "Non Available"
  }, {
    path: "/esfcommon-captcha-wy",
    component: _2a1e7119,
    name: "captcha"
  }, {
    path: "/esfcommon-captcha-geetest",
    component: _30afa829,
    name: "captcha"
  }, {
    path: "/pcesfcommon-captcha-wy",
    component: _2a1e7119,
    name: "captcha"
  }, {
    path: "/pcesfcommon-captcha-geetest",
    component: _30afa829,
    name: "captcha"
  }, {
    path: "/:city([a-z]+)/trendency/",
    component: _99ace6c2,
    name: "city-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_id(\\d+)_:block_id(\\d+)/",
    component: _99ace6c2,
    name: "block-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_id(\\d+)/",
    component: _99ace6c2,
    name: "area-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/community/:comm_id",
    component: _99ace6c2,
    name: "community-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_id(\\d+)-q-:shangquan_id(\\d+)/",
    component: _99ace6c2,
    name: "shangquan-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_py(\\w+)/",
    component: _99ace6c2,
    name: "area-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_py(\\w+)-q-:shangquan_py(\\w+)/",
    component: _99ace6c2,
    name: "shangquan-trendency"
  }, {
    path: "/ershou-autorank/synList",
    component: _b4ca1c58,
    name: "syn-rankList"
  }, {
    path: "/feapp/ershou-autorank/synList",
    component: _b4ca1c58,
    name: "syn-rankList-wb"
  }, {
    path: "/ershou-autorank/common",
    component: _89067158,
    name: "syn-com"
  }, {
    path: "/:city([a-z]+)/map/community",
    component: _50b081ff,
    name: "map"
  }, {
    path: "/xiaoqu/([a-zA-Z0-9]+)/map/community",
    component: _50b081ff,
    name: "mapwb"
  }, {
    path: "/agreement/carrier/:id",
    component: _678b01d6,
    name: "agreement"
  }, {
    path: "/weak/miniProgram/esf",
    component: _e6fc7bae,
    name: "weakMiniProgramESF"
  }, {
    path: "/clbCfg/common/material",
    component: _30cc39a8,
    name: "commonMaterial"
  }, {
    path: "/clb_cfg/menu/materialtemplate/materialtemplate",
    component: _30cc39a8,
    name: "commonMaterialPath"
  }, {
    path: "/agreement/samsungDownload",
    component: _7dd39a64,
    name: "samsungDownload"
  }, {
    path: "/esfcommon/app/download",
    component: _57f0a0c9,
    name: "appDownload"
  }, {
    path: "*",
    component: _6222cd93,
    name: "Not Found"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
